<div class="box">
    <div class="content" fxFlex="100">
        <div class="header" fxFlex="100">
            <span>{{changeToStatus}}</span>
            <span class="desc">Select reason to reject request.</span>
        </div>
        <div [class.d-none]="!show" fxFlex="100">
            <div class="HeaderSet">
                <span fxFlex="20">Nature</span>
                <span fxFlex="20">Request No.</span>
                <span fxFlex="20">Equipment</span>
                <span fxFlex="20">Request Date</span>
                <span fxFlex="20">POLs</span>
                <span fxFlex="20">PODs</span>
            </div>
            <div class="rowSet ">
                <ng-container [ngSwitch]="ackService.selectedRequest?.request_type?.dev_name">
                    <span fxFlex="20"
                        *ngSwitchCase="'lease'">{{ackService.selectedRequest?.transaction_type=='use'}}</span>
                    <span fxFlex="20" *ngSwitchCase="'one_way'">{{ackService.selectedRequest?.transaction_type=='use'?
                        'One Way-Use':'One Way-Supply'}}</span>
                    <span fxFlex="20" *ngSwitchCase="'buy_sell'">{{ackService.selectedRequest?.transaction_type=='use'?
                        'Trade-Buy':'Trade-Sell'}}</span>
                </ng-container>
                <span fxFlex="20">{{ackService.selectedRequest?.request_number}}</span>

                <span fxFlex="20" *ngFor="let item of ackService.selectedRequest?.requirement">
                    {{item?.quantity}}*{{item?.container_size_type?.display}} ({{item?.condition?.value}})
                </span>

                <span fxFlex="20"> {{ackService.selectedRequest?.request_date == null ? "-" :
                    ackService.selectedRequest?.request_date |
                    date:"dd MMM, yyyy"}}</span>

                <span fxFlex="20" *ngIf="ackService.selectedRequest?.pols.length">
                    {{ackService.selectedRequest?.pols[0].name_display}}
                    <ng-container *ngIf="ackService.selectedRequest?.pols?.length>1">
                        <p [matTooltip]="ackService.selectedRequest?.pols | tooltipList " matTooltipClass="tooltip-list"
                            matTooltipHideDelay="2000">
                            + {{ackService.selectedRequest?.pols?.length - 1}} more
                        </p>
                    </ng-container>
                </span>

                <span fxFlex="20" *ngIf="ackService.selectedRequest?.pods.length">
                    {{ackService.selectedRequest?.pods[0].name_display}}
                    <ng-container *ngIf="ackService.selectedRequest?.pods?.length>1">
                        <p [matTooltip]="ackService.selectedRequest?.pods | tooltipList" matTooltipClass="tooltip-list"
                            matTooltipHideDelay="2000">
                            + {{ackService.selectedRequest?.pods?.length - 1}} more
                        </p>
                    </ng-container>
                </span>
            </div>
        </div>

        <div class="input" fxFlex="100">
            <div class="field">
                <span>Decline Reason* </span>
                <app-select-field [isEditable]="true" [(ngModel)]="rejectObject.decline_reason"
                    [name]="'decline_reason'" [displayField]="'reason'" [options]="reason_List?.results"
                    class="align-items-center" [errors]="errorObj.decline_reason">
                </app-select-field>
            </div>
            <div class="field">
                <span>Remark</span>
                <app-text-field [isMultiline]="true" [isEditable]="true" [(ngModel)]="rejectObject.remarks"
                    [name]="'name'" [errors]="errorObj.remarks">
                </app-text-field>
            </div>
            <span class="depot-port">{{errorObj.status}} </span>

        </div>
    </div>
    <div class="btnSet" fxFlex="100">
        <button mat-raised-button class="Cancel" (click)="resetExpand()">Cancel</button>
        <button mat-raised-button class="Save" (click)="rejectRequest()">Reject</button>
    </div>
</div>
<div class="bg" [class.set]="true"></div>